import { render, staticRenderFns } from "./UpcomingChart.vue?vue&type=template&id=1e39c132"
import script from "./UpcomingChart.vue?vue&type=script&lang=js"
export * from "./UpcomingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports